import React ,{Component } from 'react';
import Patient from '../views/patient';
import { patientActions,cityActions,provinceActions,countyActions } from "../../actions";
import { connect } from 'react-redux';
import { objConstants} from '../../constants/obj.constants'
import { history } from '../../helpers';
import { withRouter } from "react-router-dom";
import uuidv4 from 'uuid';
class PatientContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isStep:false
          }
        this.submit = this.submit.bind(this);
        this.submitStep = this.submitStep.bind(this);
    }
    
    submit(event) {

        event.preventDefault();
        let data = this.refs.child.getData();
        const { dispatch } = this.props;
        this.setState({
            isStep:false
        })
        //console.log('data',data);
        if(data.Id)
        {
            dispatch(patientActions.edit(data,data.Id));

        }else{

            dispatch(patientActions.add(data));

        }
        
        //console.log(data);
    
    }

    submitStep(event) {

        event.preventDefault();
        let data = this.refs.child.getData();
        const { dispatch } = this.props;
        this.setState({
            isStep:true
        })
        //console.log('data',data);
     
        data.Id=uuidv4();
        dispatch(patientActions.add(data));

        //console.log(data);
    
    }

    componentDidMount(){
       

       const {patientId}=this.props.match.params;
       // console.log('Props',this.props);
       const { dispatch } = this.props;   
       dispatch(cityActions.gets());
       dispatch(provinceActions.gets());
       dispatch(countyActions.gets());


         if (patientId) {

            let id = patientId;
             
            dispatch(patientActions.get(id));
            
           
        
        } 
    }

    render() { 

        const { type,obj,error } = this.props;
        const {isStep}=this.state;

        console.log('error',error)
        //console.log('TYPE',type);
        if(type==objConstants.ADD_SUCCESS)
        {
            console.log('Added successfully',isStep);
            console.log('aaaaaaaaa',obj)
            if(isStep)
            {
                console.log('obj',obj);
                if(obj)
                {
                    console.log('aaaaaaaaa','/certrequest/new/'+obj.Id)

                    history.push('/certrequest/new/'+obj.Id)
                }

            }else{
                history.push('/patients')
            }
           
        }
        if(type==objConstants.UPDATE_SUCCESS)
        {
           // console.log('Updated successfully');
            history.push('/patients')
        }
       



        return ( 
            <Patient submitHandler={this.submit} submitStepHandler={this.submitStep} model={this.props.obj} provincelist={this.props.items && this.props.items.provinceList} countylist={this.props.items && this.props.items.countyList} citylist={this.props.items && this.props.items.cityList} {...this.props}  ref="child" />
         );
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items,error } = state.objs;
   
   //console.log('STATE',state)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items,
        error      
    };
} 

export default withRouter(connect(mapStateToProps)(PatientContainer));